import React from 'react';
import {connect} from 'react-redux';
import {Field} from "redux-form";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormTextAreaField} from "../FormField";

class Analytics extends React.Component {

  render() {
    const {canEditFields} = this.props.accountPageInfo;

    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.analytics)}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.analytics)}
                     title="Analytics">
        <div className="acc-container">
          <div className="acc-container__row">
            <div className="acc-block">
              <Field name="analytics" style={{height: "100px"}} component={FormTextAreaField} label="Analytics"
                     disabled={!canEditFields}
                     placeholder="Copy/Paste your Analytics code here"/>
            </div>
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  const {accountPageInfo} = store.accountState;
  return {
    accountPageInfo,
    sectionsOpened: store.accountState.sectionsOpened
  };
};

const mapDispatchToProps = {
  toggleSectionOpened
};

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);

